export const legalRequirements = [
  {
    id: 'aml-3-1',
    section: '§ 3-1',
    title: 'Krav til systematisk helse-, miljø- og sikkerhetsarbeid',
    description: 'Arbeidsgiver skal sørge for at det utføres systematisk HMS-arbeid på alle plan i virksomheten.',
    checks: [
      { id: 'hms-1', label: 'Etablert HMS-håndbok', weight: 20 },
      { id: 'hms-2', label: 'Gjennomført årlig vernerunde', weight: 15 },
      { id: 'hms-3', label: 'Oversikt over risikovurderinger', weight: 25 },
      { id: 'hms-4', label: 'Oppdatert handlingsplan', weight: 20 }
    ]
  },
  {
    id: 'aml-4-1',
    section: '§ 4-1',
    title: 'Generelle krav til arbeidsmiljøet',
    description: 'Arbeidsmiljøet skal være fullt forsvarlig ut fra en enkeltvis og samlet vurdering.',
    checks: [
      { id: 'env-1', label: 'Vurdering av fysiske arbeidsforhold', weight: 20 },
      { id: 'env-2', label: 'Tilrettelegging for ansatte', weight: 15 },
      { id: 'env-3', label: 'Belysning og inneklima-måling', weight: 10 }
    ]
  },
  {
    id: 'aml-4-3',
    section: '§ 4-3',
    title: 'Psykososialt arbeidsmiljø',
    description: 'Arbeidet skal legges til rette slik at ansattes verdighet og integritet ivaretas.',
    checks: [
      { id: 'psy-1', label: 'Rutiner mot trakassering', weight: 30 },
      { id: 'psy-2', label: 'Kartlegging av psykososialt miljø', weight: 25 },
      { id: 'psy-3', label: 'Oppfølgingssamtaler gjennomført', weight: 15 }
    ]
  }
];

export const getComplianceStatus = (score) => {
  if (score >= 90) return { label: 'Fullstendig Samsvar', color: 'emerald', icon: 'ShieldCheck' };
  if (score >= 70) return { label: 'Godkjent med merknader', color: 'indigo', icon: 'AlertCircle' };
  if (score >= 50) return { label: 'Under oppfølging', color: 'amber', icon: 'Clock' };
  return { label: 'Kritisk mangel', color: 'rose', icon: 'XCircle' };
};